import { render, staticRenderFns } from "./dialog-managefeature.vue?vue&type=template&id=5333f5e6&"
import script from "./dialog-managefeature.vue?vue&type=script&lang=js&"
export * from "./dialog-managefeature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports